import NewTCExecutive from "../../features/marketingExecutive/NewTCExecutive"

const NewTCExecutiveManager = () => {
  return <NewTCExecutive />
}

export default NewTCExecutiveManager